import { patchUsersId, type UserUpdateDto } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { USER_DETAIL } from "Settings/User/Api/Query/useUserByIdQuery";
import { USER_PROFILE } from "Settings/User/Api/Query/useUserProfileQuery";
import { USERS_LIST } from "Settings/User/Api/Query/useUsersListQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const userMutationsResource = Resources.base.user.mutations;

export const useUpdateUser = (userId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: UserUpdateDto) =>
			patchUsersId(data, userId),
		),
		onError: (error) => {
			console.error(`${t(userMutationsResource.userUpdateError)}:`, error);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: [USERS_LIST] }),
				queryClient.invalidateQueries({ queryKey: [USER_DETAIL, userId] }),
				queryClient.invalidateQueries({ queryKey: [USER_PROFILE] }),
			]);
			toast.success(t(userMutationsResource.userUpdateSuccess));
		},
	});
};
